import { render, staticRenderFns } from "./cervixIn.vue?vue&type=template&id=2f5ddac2&scoped=true"
import script from "./cervixIn.vue?vue&type=script&lang=js"
export * from "./cervixIn.vue?vue&type=script&lang=js"
import style0 from "./cervixIn.vue?vue&type=style&index=0&id=2f5ddac2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ddac2",
  null
  
)

export default component.exports